import AliasInfoModal from './AliasInfo';
export default AliasInfoModal;
